selectHeadGuardian();

function selectHeadGuardian(){

    var AjaxController = require('./services/AjaxController');

    $('.js-select-head-guardian').on('click', function(){

        var $this = $(this),
            roomId = $this.data('room'),
            url = '/api/rooms/select-head-guardian';

        var data = {
            field: 'head_guardian',
            roomId: roomId,
            value: ($this.prop('checked')) ? 1 : 0
        };
        var success = function (response) {
            //console.log('Success');
        }
        var error = function (response) {
            //console.log('Error');
        }

        AjaxController.prototype.send(url, data, success, error);
    });


};